<template>
  <div class="neogreen-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="neogreen-aboutusbox">
    </div>
    <div class="aboutus-box">
      <div class="title">About Us</div>
      <div class="text">Build a solid financial future together</div>
      <div class="content">
        <div class="left">
          <img src="../assets/aboutLeft.png" alt="">
        </div>
        <div class="right">
          <span>In this challenging financial world, we always insist on providing you with the most professional and
            reliable financial services. Whether you're trying to understand your credit standing or looking for an
            effective way to achieve your financial goals, we're here to help. Our team of experienced financial experts
            is dedicated to providing you with personalized financial advice and comprehensive financial planning.
            Partner with us and you’ll have the confidence, security and wisdom to start your journey to financial
            freedom. Whether your goal is a loan, home purchase or investment, we will work with you to realize your
            financial dreams.
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="milk-box">
      <div class="item">
        <img src="../assets/milk1.png" alt="">
        <p>8000</p>
        <span>Serving customers</span>
      </div>
      <div class="item">
        <img src="../assets/milk2.png" alt="">
        <p>6,000</p>
        <span>Acres of manor</span>
      </div>
      <div class="item">
        <img src="../assets/milk3.png" alt="">
        <p>16000</p>
        <span>Organic cream</span>
      </div>
      <div class="item">
        <img src="../assets/milk4.png" alt="">
        <p>300+</p>
        <span>Cultivated products</span>
      </div>
    </div> -->
    <div class="services-box">
      <div class="title">Some More Services</div>
      <div class="text">Provide diverse services</div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/someMore1.png" alt="">
          <p>Investment Advice</p>
        </div>
        <div class="item">
          <img src="../assets/someMore2.png" alt="">
          <p>Credit Assessment</p>
        </div>
        <div class="item">
          <img src="../assets/someMore3.png" alt="">
          <p>Personalized Recommendations</p>
        </div>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/someMore4.png" alt="">
          <p>Credit Report</p>
        </div>
        <div class="item">
          <img src="../assets/someMore5.png" alt="">
          <p>Financial Planning</p>
        </div>
        <div class="item">
          <img src="../assets/someMore6.png" alt="">
          <p>Financial Advisory
          </p>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.neogreen-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 400px;
  background-size: 100% 100%;
  overflow: hidden;
}

.aboutus-box {
  padding: 100px 360px 70px;

  .title {
    margin-bottom: 5px;
    font-size: 48px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 68px;
    text-align: center;
  }

  .text {
    margin-bottom: 53px;
    font-size: 14px;
    font-family: ArialMT;
    color: #3B54EA;
    line-height: 16px;
    text-align: center;
  }

  .content {
    display: flex;
    justify-content: space-between;

    .left {
      margin-right: 44px;

      img {
        width: 510px;
        height: 465px;
      }
    }

    .right {
      p {
        font-size: 28px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #333333;
        line-height: 40px;
      }

      span {
        font-size: 20px;
        font-family: ArialMT;
        color: #999999;
        line-height: 32px;
      }
    }
  }
}

.milk-box {
  padding: 70px 360px;
  display: flex;
  justify-content: space-between;
  background-color: #000;

  .item {
    text-align: center;

    img {
      margin-bottom: 20px;
      width: 40px;
      height: 40px;
    }

    p {
      margin-bottom: 5px;
      font-size: 32px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 45px;
    }

    span {
      font-size: 18px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #FFFFFF;
      line-height: 26px;
    }
  }
}

.services-box {
  padding: 80px 410px;
  background: #3B54EA;
  text-align: center;

  .title {
    font-size: 48px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #FFFFFF;
    line-height: 68px;
  }

  .text {
    font-size: 14px;
    font-family: ArialMT;
    color: #FFFFFF;
    line-height: 16px;
  }

  .item-box {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;

    .item {
      margin-right: 30px;
      background-color: #fff;
      max-width: 350px;

      img {
        width: 350px;
        height: 238px;
      }

      p {
        margin-bottom: 7px;
        font-size: 18px;
        font-family: Arial, Arial;
        font-weight: 900;
        color: #3B54EA;
        line-height: 26px;
      }

      span {
        display: block;
        margin-bottom: 16px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
